<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar v-if="reviewMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title>Edit Account No. Suffix </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-else-if="queryMode" dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Query Account No. Suffix </v-toolbar-title>
        </v-toolbar>
        <v-toolbar v-if="newAcctNoSfx" dense color="grey lighten-3" flat>
          <v-icon>mdi-plus</v-icon>
          <v-toolbar-title>Create New Account No. Suffix</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-sm>
            <v-layout row>
              <v-flex xs6 v-if="newAcctNoSfx">
                <v-text-field
                  v-model="acctNoSfxForm.acctNoSfx"
                  :label="labels.acctNoSfx"
                  :error-messages="errors.collect('acctNoSfx')"
                  data-vv-name="acctNoSfx"
                  :data-vv-as="labels.acctNoSfx"
                  v-validate="'required|param|max:4'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
                <div class="queryValue">{{ acctNoSfxForm.acctNoSfx }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :disabled="queryMode"
                  v-model="acctNoSfxForm.description"
                  :label="labels.description"
                  :error-messages="errors.collect('description')"
                  data-vv-name="description"
                  :data-vv-as="labels.description"
                  v-validate="'required|entry|max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <!-- OS-1249 -->
              <!-- <v-flex xs6>
                <v-text-field
                  :disabled="queryMode"
                  v-model="acctNoSfxForm.acctNoSfxClmRI"
                  :label="labels.acctNoSfxClmRI"
                  :error-messages="errors.collect('acctNoSfxClmRI')"
                  data-vv-name="acctNoSfxClmRI"
                  :data-vv-as="labels.acctNoSfxClmRI"
                  v-validate="'max:4'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('clmRi')"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs6>
                <v-text-field
                  :disabled="queryMode"
                  v-model="acctNoSfxForm.acctNoSfxRiskArea"
                  :label="labels.acctNoSfxRiskArea"
                  :error-messages="errors.collect('acctNoSfxRiskArea')"
                  data-vv-name="acctNoSfxRiskArea"
                  :data-vv-as="labels.acctNoSfxRiskArea"
                  v-validate="'max:4'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('riskArea')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :disabled="queryMode"
                  v-model="acctNoSfxForm.acctNoSfxCedArea"
                  :label="labels.acctNoSfxCedArea"
                  :error-messages="errors.collect('acctNoSfxCedArea')"
                  data-vv-name="acctNoSfxCedArea"
                  :data-vv-as="labels.acctNoSfxCedArea"
                  v-validate="'max:4'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('cedArea')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <!-- <v-flex xs6>
                <v-text-field
                  :disabled="queryMode"
                  v-model="acctNoSfxForm.acctNoSfxCedArea"
                  :label="labels.acctNoSfxCedArea"
                  :error-messages="errors.collect('acctNoSfxCedArea')"
                  data-vv-name="acctNoSfxCedArea"
                  :data-vv-as="labels.acctNoSfxCedArea"
                  v-validate="'max:4'"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('cedArea')"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs6> </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ acctNoSfxForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ acctNoSfxForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newAcctNoSfx">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ acctNoSfxForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ acctNoSfxForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="doCancel">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
          <v-btn color="primary" v-if="!queryMode" dark @click="doSave">
            Save Account No. Suffix
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
        <v-spacer class="mt-2"></v-spacer>
        <template v-if="!newAcctNoSfx">
          <v-divider></v-divider>
          <acct-no-sfx-map :acctNoSfx="acctNoSfx"></acct-no-sfx-map>
        </template>
      </v-card>
      <!-- helplist -->
      <v-dialog v-model="helplist" width="900px" persistent>
        <acctnosfx-help-list
          v-if="this.acctNoSfxHelpList"
          :fieldName="this.helpListFieldName"
          @close="doClose"
          @selectAcctNoSfx="doAssign($event)"
        ></acctnosfx-help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import AcctNoSfxMap from './AcctNoSfxMap'
import AcctNoSfxHelpList from './helplist/AcctNoSfxHelplist'
export default {
  data() {
    return {
      labels: {
        acctNoSfx: 'Account No. Suffix',
        description: 'Description',
        acctNoSfxClmRI: 'Claims RI',
        acctNoSfxRiskArea: 'Treaty Risk Area',
        acctNoSfxCedArea: 'Treaty Cedant Area',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      acctNoSfxForm: {
        acctNoSfx: null,
        description: null,
        acctNoSfxClmRI: null,
        acctNoSfxRiskArea: null,
        acctNoSfxCedArea: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      review: false,
      reviewMode: false,
      queryMode: false,
      helplist: false,
      acctNoSfxHelpList: false,
      helpListFieldName: undefined,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newAcctNoSfx) {
        const apiURI = this.menu.getAcctNoSfx
        if (apiURI) {
          try {
            const expand = {
              acctNoSfx: this.acctNoSfx
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.acctNoSfxForm.acctNoSfx = data.acctNoSfx.acctNoSfx
              this.acctNoSfxForm.description = data.acctNoSfx.description
              this.acctNoSfxForm.acctNoSfxClmRI = data.acctNoSfx.acctNoSfxClmRI
              this.acctNoSfxForm.acctNoSfxRiskArea = data.acctNoSfx.acctNoSfxRiskArea
              this.acctNoSfxForm.acctNoSfxCedArea = data.acctNoSfx.acctNoSfxCedArea
              this.acctNoSfxForm.createdBy = data.createdBy
              this.acctNoSfxForm.createdDate = data.createdDate
              this.acctNoSfxForm.modifiedBy = data.modifiedBy
              this.acctNoSfxForm.modifiedDate = data.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.acctNoSfxForm.acctNoSfx = null
        this.acctNoSfxForm.description = null
        this.acctNoSfxForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.acctNoSfxForm.createdDate = new Date()
      }
    },
    async doSave() {
      this.$validator.validateAll().then((result) => {
        if (this.acctNoSfxForm.acctNoSfxClmRI === '') {
          this.acctNoSfxForm.acctNoSfxClmRI = null
        }
        if (this.acctNoSfxForm.acctNoSfxRiskArea === '') {
          this.acctNoSfxForm.acctNoSfxRiskArea = null
        }
        if (this.acctNoSfxForm.acctNoSfxCedArea === '') {
          this.acctNoSfxForm.acctNoSfxCedArea = null
        }
        if (result) {
          const config = {
            method: this.newAcctNoSfx ? 'post' : 'put',
            url: this.newAcctNoSfx ? this.menu.createAcctNoSfx : this.menu.updateAcctNoSfx,
            data: this.acctNoSfxForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                if (this.newAcctNoSfx) {
                  this.$router.push({
                    name: 'acctNoSfxDet',
                    params: {
                      acctNoSfx: this.acctNoSfxForm.acctNoSfx
                    }
                  })
                } else {
                  this.doInit()
                }
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'acctNoSfx' })
    },
    getHelpList(fieldname) {
      this.helplist = true
      this.acctNoSfxHelpList = true
      if (fieldname === 'clmRi') {
        this.helpListFieldName = 'clmRi'
      } else if (fieldname === 'riskArea') {
        this.helpListFieldName = 'riskArea'
      } else if (fieldname === 'cedArea') {
        this.helpListFieldName = 'cedArea'
      }
    },
    doAssign(acctNoSfxObj) {
      if (this.helpListFieldName === 'clmRi') {
        this.$validator.errors.remove('acctNoSfxClmRI')
        this.acctNoSfxForm.acctNoSfxClmRI = acctNoSfxObj.acctNoSfx
      } else if (this.helpListFieldName === 'riskArea') {
        this.$validator.errors.remove('acctNoSfxRiskArea')
        this.acctNoSfxForm.acctNoSfxRiskArea = acctNoSfxObj.acctNoSfx
      } else if (this.helpListFieldName === 'cedArea') {
        this.$validator.errors.remove('acctNoSfxCedArea')
        this.acctNoSfxForm.acctNoSfxCedArea = acctNoSfxObj.acctNoSfx
      }
    },
    doClose() {
      this.helplist = false
      this.helpListFieldName = undefined
      this.acctNoSfxHelpList = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.acctNoSfxParam.menu
    },
    newAcctNoSfx() {
      return this.acctNoSfx === 'new'
    },
    acctNoSfxMode() {
      return this.$route.params.acctNoSfxMode
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  created() {
    if (this.acctNoSfxMode === 'Query') {
      this.queryMode = true
    } else if (this.acctNoSfxMode === 'Review') {
      this.reviewMode = true
    }
  },
  watch: {
    acctNoSfx(value) {
      this.doInit()
    }
  },
  components: {
    AcctNoSfxMap,
    'acctnosfx-help-list': AcctNoSfxHelpList
  },
  mixins: [MessageMixin],
  props: ['acctNoSfx']
}
</script>

<style>
</style>
